<!-- Page.vue -->
<script setup lang="ts">
import { useDisplay } from 'vuetify'
import { computed } from 'vue'

const { mdAndDown } = useDisplay()
const isMobile = computed(() => mdAndDown.value)
defineProps<{ noHeaderBg?: boolean; eventForm?: boolean }>()
</script>

<template>
  <v-sheet class="main-board">
    <!-- Header -->
    <v-sheet v-if="$slots['page-title']" class="page-title-slot">
      <slot name="page-title" />
    </v-sheet>

    <!-- Main Content -->
    <v-main
      class="page-main"
      :class="isMobile ? 'px-0 py-0' : 'px-5 py-6'"
      :style="{ '--v-layout-top': '64px' }"
    >
      <slot />
    </v-main>

    <!-- Footer -->
    <v-footer
      v-if="$slots.footer"
      :height="eventForm ? '112' : '64'"
      :elevation="1"
      class="page-footer d-flex align-center ga-4 justify-center px-4"
      :class="{
        'bg-white': !eventForm,
        'bg-transparent': eventForm,
      }"
      style="
        border-top: 1px solid var(--v-theme-grey-8);
        backdrop-filter: blur(6px);
      "
    >
      <slot name="footer" />
    </v-footer>
  </v-sheet>
</template>

<style scoped>
.main-board {
  box-sizing: border-box; /* <-- principal correção */
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  border: 1px solid var(--grey-grey-lighten-2-stroke, #e0e0e0);
  background: #fff;
  border-radius: 16px;
  overflow: hidden; /* pode manter, mas o overflow-x hidden acima ajuda */
}

.page-main {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

/* redundância explícita: garante 100% mesmo que o align-self mude em outro lugar */
.page-title-slot,
.page-main,
.page-footer {
  align-self: stretch;
  width: 100%;
}
</style>
